import { useEffect, useRef } from "react";

/**
 * React wrapper around the official Stripe Buy Button custom element.
 * https://docs.stripe.com/payment-links/buy-button
 */
export default function StripeBuyButton({ buyButtonId, publishableKey, testId }) {
  const ref = useRef(null);

  useEffect(() => {
    // Force the custom element to render correctly after mount
    if (ref.current) {
      ref.current.setAttribute("buy-button-id", buyButtonId);
      ref.current.setAttribute("publishable-key", publishableKey);
    }
  }, [buyButtonId, publishableKey]);

  return (
    <div className="flex justify-center w-full" data-testid={testId}>
      {/* eslint-disable-next-line react/no-unknown-property */}
      <stripe-buy-button
        ref={ref}
        buy-button-id={buyButtonId}
        publishable-key={publishableKey}
      />
    </div>
  );
}
